import { QuestionCore } from '../../types'

export const METRIEK_QUESTIONS: QuestionCore[] = [
  {
    id: 'MET-OMT-L1-001',
    module: 'Metriek',
    difficulty: 1,
    context:
      'Een tuin is 12 meter lang en 8 meter breed. Er moet een nieuw hek omheen.',
    question: 'Hoeveel meter hek is er nodig voor de hele tuin?',
    options: ['20 meter', '40 meter', '96 meter', '80 meter'],
    correctAnswer: 1,
  },
  {
    id: 'MET-OMT-L2-001',
    module: 'Metriek',
    difficulty: 2,
    question:
      'Een rechthoekig zwembad is 10 meter lang en 5 meter breed. Je loopt 3 rondjes om het zwembad. Hoeveel meter heb je gelopen?',
    options: ['45 meter', '30 meter', '90 meter', '150 meter'],
    correctAnswer: 2,
  },
  {
    id: 'MET-INH-L1-001',
    module: 'Metriek',
    difficulty: 1,
    question:
      'In een fles frisdrank zit 1,5 liter. Je schenkt glazen van 250 ml in. Hoeveel glazen haal je uit de fles?',
    options: ['4 glazen', '6 glazen', '10 glazen', '15 glazen'],
    correctAnswer: 1,
  },
  {
    id: 'MET-OPP-L3-002',
    module: 'Metriek',
    difficulty: 3,
    question:
      'De oppervlakte van een vierkant is 36 $cm^2$. Hoe lang is één zijde?',
    options: ['6 cm', '9 cm', '18 cm', '4 cm'],
    correctAnswer: 0,
  },
  {
    id: 'MET-LEN-L2-002',
    module: 'Metriek',
    difficulty: 2,
    question: 'Hoeveel decimeter (dm) is 4,5 kilometer?',
    options: ['450 dm', '4.500 dm', '45.000 dm', '450.000 dm'],
    correctAnswer: 2,
  },
  {
    id: 'MET-INH-L3-001',
    module: 'Metriek',
    difficulty: 3,
    question:
      'Een doos is 5 dm lang, 4 dm breed en 3 dm hoog. Wat is de inhoud in liters?',
    options: ['12 liter', '60 liter', '120 liter', '20 liter'],
    correctAnswer: 1,
  },
  {
    id: 'MET-OPP-L1-001',
    module: 'Metriek',
    difficulty: 1,
    question:
      'De juf wil nieuwe tegels in het klaslokaal. Het lokaal is 8 meter lang en 6 meter breed. Hoeveel vierkante meter ($m^2$) tegels moet ze kopen?',
    options: ['14 $m^2$', '48 $m^2$', '28 $m^2$', '48 m'],
    correctAnswer: 1,
  },
  {
    id: 'MET-LEN-L2-001',
    module: 'Metriek',
    difficulty: 2,
    question:
      'Djayden fietst naar school. De afstand is 1,5 kilometer. Hoeveel meter is dat?',
    options: ['150 meter', '1500 meter', '15 meter', '15.000 meter'],
    correctAnswer: 1,
  },
  {
    id: 'MET-INH-L2-001',
    module: 'Metriek',
    difficulty: 2,
    question:
      'Op een pak melk staat 1 L (liter). Jeroen drinkt een beker van 2 dl (deciliter). Hoeveel dl zit er nog in het pak?',
    options: ['0,8 dl', '8 dl', '98 dl', '1,2 dl'],
    correctAnswer: 1,
  },
  {
    id: 'MET-OMT-L3-001',
    module: 'Metriek',
    difficulty: 3,
    question:
      'Een rechthoekig voetbalveld heeft een omtrek van 300 meter. De lengte is 100 meter. Wat is de breedte?',
    options: ['200 meter', '50 meter', '100 meter', '150 meter'],
    correctAnswer: 1,
  },
  {
    id: 'MET-OPP-L3-001',
    module: 'Metriek',
    difficulty: 3,
    question:
      'De oppervlakte van een vierkant schilderij is 81 $cm^2$. Hoe lang is één zijkant?',
    options: ['9 cm', '20,25 cm', '40,5 cm', '81 cm'],
    correctAnswer: 0,
  },
  {
    id: 'MET-LEN-L1-002',
    module: 'Metriek',
    difficulty: 1,
    question: 'Een lint is 250 centimeter lang. Hoeveel meter is dat?',
    options: ['0,25 m', '2,5 m', '25 m', '250 m'],
    correctAnswer: 1,
  },
  {
    id: 'MET-GEW-L1-001',
    module: 'Metriek',
    difficulty: 1,
    question: 'Een doos weegt 3 kilogram. Hoeveel gram is dat?',
    options: ['30 g', '300 g', '3.000 g', '30.000 g'],
    correctAnswer: 2,
  },
  {
    id: 'MET-OMT-L1-002',
    module: 'Metriek',
    difficulty: 2,
    question:
      'Een rechthoek heeft een lengte van 9 meter en een breedte van 4 meter. Wat is de omtrek?',
    options: ['13 meter', '26 meter', '36 meter', '72 meter'],
    correctAnswer: 1,
  },
  {
    id: 'MET-INH-L1-002',
    module: 'Metriek',
    difficulty: 2,
    question:
      'In een emmer zit 7,5 liter water. Je giet dit in flessen van 1,5 liter. Hoeveel flessen kun je vullen?',
    options: ['3 flessen', '4 flessen', '5 flessen', '6 flessen'],
    correctAnswer: 2,
  },
  {
    id: 'MET-OPP-L2-001',
    module: 'Metriek',
    difficulty: 3,
    question:
      'Een kamer is 4 meter lang en 3,5 meter breed. Hoeveel vierkante meter vloerbedekking is nodig?',
    options: ['7 $m^2$', '14 $m^2$', '28 $m^2$', '12 $m^2$'],
    correctAnswer: 1,
  },
  {
    id: 'MET-INH-L2-002',
    module: 'Metriek',
    difficulty: 3,
    question:
      'Een balk is 2 meter lang, 50 centimeter breed en 20 centimeter hoog. Wat is de inhoud in kubieke decimeters ($dm^3$)?',
    options: ['20 $dm^3$', '200 $dm^3$', '100 $dm^3$', '2.000 $dm^3$'],
    correctAnswer: 2,
  },
  {
    id: 'MET-INH-L3-002',
    module: 'Metriek',
    difficulty: 3,
    question:
      'Een zwembad wordt gevuld met 18.000 liter water. Hoeveel kubieke meter ($m^3$) is dat?',
    options: ['1,8 $m^3$', '18 $m^3$', '180 $m^3$', '1.800 $m^3$'],
    correctAnswer: 1,
  },
  {
    id: 'MET-LEN-L3-001',
    module: 'Metriek',
    difficulty: 3,
    question:
      'Een pad is 120 meter lang. Elke tegel is 40 centimeter lang. Hoeveel tegels zijn nodig?',
    options: ['30', '120', '300', '3.000'],
    correctAnswer: 2,
  },
  {
    id: 'MET-GEW-L1-002',
    module: 'Metriek',
    difficulty: 1,
    question:
      'Een appel weegt 200 gram. Hoeveel appels wegen samen 1 kilogram?',
    options: ['5 appels', '10 appels', '2 appels', '20 appels'],
    correctAnswer: 0,
  },
  {
    id: 'MET-GEW-L2-001',
    module: 'Metriek',
    difficulty: 2,
    question: 'Een zak aardappelen weegt 2,5 kilogram. Hoeveel gram is dat?',
    options: ['2.500 gram', '250 gram', '25 gram', '25.000 gram'],
    correctAnswer: 0,
  },
  {
    id: 'MET-INH-L2-003',
    module: 'Metriek',
    difficulty: 2,
    question:
      'In een emmer zit 8 liter water. Je giet dit in bekers van 500 ml. Hoeveel bekers kun je vullen?',
    options: ['16 bekers', '8 bekers', '4 bekers', '32 bekers'],
    correctAnswer: 0,
  },
  {
    id: 'MET-GEW-L3-001',
    module: 'Metriek',
    difficulty: 3,
    question:
      'Een vrachtwagen mag maximaal 3.500 kilogram laden. Er staan al dozen van samen 2.750 kg in. Hoeveel kilogram mag er nog bij?',
    options: ['750 kg', '850 kg', '650 kg', '1.000 kg'],
    correctAnswer: 0,
  },
  {
    id: 'MET-INH-L3-003',
    module: 'Metriek',
    difficulty: 3,
    question:
      'Een aquarium is 50 cm lang, 30 cm breed en 40 cm hoog. Hoeveel liter water past erin?',
    options: ['60 liter', '120 liter', '30 liter', '600 liter'],
    correctAnswer: 0,
  },
]
